import React, { Component } from 'react';

class Header extends Component {
    render() {
        return (
            <div className="parallax-header parallax">
                <h1 className="h1Header" style={{textAlign:'center'}}>Night Scenes</h1>
            </div>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/header/Header.js